import { VExpense } from './../Model/Account/VExpense';
import { VoucherEntry } from './../Model/Account/VoucherEntry';
import { AccLedgarMaster } from './../Model/Account/AccLedgarMaster';
import { AccLedgerGroupmaster } from './../Model/Account/AccLedgerGroupmaster';
import { environment } from './../../environments/environment';
import { Injectable, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Texpense } from '../Model/Account/Texpense';
import { EmailPartyBill } from '../Model/EmailPartyBill';

@Injectable( {
  providedIn: 'root'
} )
export class AccountService
{


  constructor ( private _httpClient: HttpClient ) { }

  //============================================Add Ledger Group====================================
  AddLedgerGroup ( input: AccLedgerGroupmaster ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "LedgarGroupMaster", body, httpOptions );
  }

  UpdateLedgerGroup ( input: AccLedgerGroupmaster ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "LedgarGroupMaster", body, httpOptions );
  }

  GETLedgerGroup (): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarGroupMaster", httpOptions );
  }

  DeleteLedgerGroup ( sgroupcode: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "LedgarGroupMaster?sgroupcode=" + sgroupcode + "&iUserId=" + iUserId, httpOptions );
  }

  GETLedgerReference ( ledgertype: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarFor?ledgertype=" + ledgertype, httpOptions );
  }


  //============================================Ledger Master====================================
  AddLedger ( input: AccLedgarMaster ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "LedgarMaster", body, httpOptions );
  }

  UpdateLedger ( input: AccLedgarMaster ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "LedgarMaster", body, httpOptions );
  }

  GETLedgerList ( grpu: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarMaster?grpu=" + grpu, httpOptions );
  }
  GETLedgerListByGroup ( intype: number, ledgergroup: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarMaster?intype=" + intype + "&ledgergroup=" + ledgergroup, httpOptions );
  }

  DeleteLedger ( ledgarcode: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "LedgarMaster?ledgarcode=" + ledgarcode + "&iUserId=" + iUserId, httpOptions );
  }

  GETLedgerData ( intype: number, ledgerCode: string, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarMaster?intype=" + intype + "&ledgerCode=" + ledgerCode + "&fromdate=" + fromdate + "&todate=" + todate + "&Optionalparameter=''", httpOptions );
  }

  GETLedgerDataNew ( intype: number, ledgerCode: string, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarFor?intype=" + intype + "&ledgercode=" + ledgerCode + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }

  GETLedgerDDetail ( intype: number, ledgerCode: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarFor?intype=" + intype + "&ledgerCode=" + ledgerCode, httpOptions );
  }

  GETLedgerSummaryData ( intype: number, ledgergroup: string, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarMaster?intype=" + intype + "&ledgergroup=" + ledgergroup + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }


  GETPartyLedgerData ( intype: number, ledgerCode: string, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "LedgarMaster?intype=" + intype + "&ledgerCode=" + ledgerCode + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }



  //====================================Voucher Entry=====================================

  AddVoucherEntry ( input: VoucherEntry ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "Voucherentry", body, httpOptions );
  }

  UpdateVoucherEntry ( input: VoucherEntry ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "Voucherentry", body, httpOptions );
  }

  DeleteVoucherEntry ( vno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "Voucherentry?vno=" + vno + "&iUserId=" + iUserId, httpOptions );
  }

  GetVoucherDetail ( vno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "Voucherentry/GetVoucherDetail?vno=" + vno, httpOptions );
  }

  GetVoucherDetailForMR ( vno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "Voucherentry?intype=0&MrOrPr='MR'&vno=" + vno, httpOptions );
  }

  GetVoucherDetailList ( vno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "Voucherentry?intype=0&vno=" + vno, httpOptions );
  }

  GetBillOrGRbyVoucher ( vno: string, billorgr: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "mrentry?vno=" + vno + "&billorgr=" + billorgr, httpOptions );
  }

  GETPAYMETAGAINSTGR ( grno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "mrentry?grno=" + grno, httpOptions );
  }

  DeleteMREntry ( vno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "mrentry?vno=" + vno + "&iUserId=" + iUserId, httpOptions );
  }

  DeletePaymentReceive ( vno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "ReceivePaymentAgainstBill?vno=" + vno + "&iUserId=" + iUserId, httpOptions );
  }

  //Outstanding Summary
  GETOutstandingSummary (): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "PartyOutstanding", httpOptions );
  }

  GETOnAccountDetail ( sPartyCode: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "PartyOutstanding?sPartyCode=" + sPartyCode, httpOptions );
  }


  //DownloadTallyData
  DownloadTallyData ( downloadfor: string, locid: number, fromdatae: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "PostTallyData?downloadfor=" + downloadfor + "&locid=" + locid + "&fromdatae=" + fromdatae + "&todate=" + todate, httpOptions );
  }

  GETTallyPostLog (): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "TallyPostedLog", httpOptions );
  }
  //=================================TripExpense=============================================================================
  AddTripExpense ( input: Texpense ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "TripExpense", body, httpOptions );
  }

  UpdateTripExpense ( input: Texpense ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "TripExpense", body, httpOptions );
  }

  GETTripExpense ( intype: number, locid: number, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "TripExpense?intype=" + intype + "&locid=" + locid + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }
  GETTripExpenseDetail ( vhno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "TripExpense?vhno=" + vhno, httpOptions );
  }

  GETTripChallanList ( intype: number, tripid: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "TripExpense?intype=" + intype + "&tripid=" + tripid, httpOptions );
  }

  DeleteTripExpense ( vno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "TripExpense?vno=" + vno + "&iUserId=" + iUserId, httpOptions );
  }
  //Branch Expense
  AddBranchExpense ( input: VoucherEntry ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "BranchExpense", body, httpOptions );
  }

  UpdateBranchExpense ( input: VoucherEntry ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "BranchExpense", body, httpOptions );
  }

  GETBranchExpense ( intype: number, locid: number, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "BranchExpense?intype=" + intype + "&locid=" + locid + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }

  DeleteBranchExpense ( vno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "BranchExpense?vno=" + vno + "&iUserId=" + iUserId, httpOptions );
  }

  //GR Expense
  AddGRExpense ( input: VoucherEntry ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "GRExpense", body, httpOptions );
  }

  UpdateGRExpense ( input: VoucherEntry ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "GRExpense", body, httpOptions );
  }

  GETGRExpense ( intype: number, grno: string, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "GRExpense?intype=" + intype + "&grno=" + grno + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }

  DeleteGRExpense ( vno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "GRExpense?vno=" + vno + "&iUserId=" + iUserId, httpOptions );
  }


  //Send Bills to Party
  SendBillsToParty ( input: EmailPartyBill ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "EmailPartyBills", body, httpOptions );
  }

  //Send Party OS
  SendOSToParty ( input: EmailPartyBill ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "EmailPartyOS", body, httpOptions );
  }

  //Get payment for reconcile
  GetPamentForReconcile ( LocId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "PaymentReconcile?LocId=" + LocId, httpOptions );
  }

  GetPamentForReconcileByDate ( LocationID: number, startdate: string, enddate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "PaymentReconcile?intype=1&LocId=" + LocationID + '&startdate=' + startdate + '&enddate=' + enddate, httpOptions );
  }

  SavePaymentReconcile ( input: any ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "PaymentReconcile", body, httpOptions );
  }

  GETBankBookData ( ledgerCode: string, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "PaymentReconcile?ledgerCode=" + ledgerCode + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }


  //=================================Vehicle Expense=============================================================================
  AddVehicleExpense ( input: VExpense ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "VehicleExpense", body, httpOptions );
  }

  GETVehicleExpense ( intype: number, locid: number, fromdate: string, todate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "VehicleExpense?intype=" + intype + "&locid=" + locid + "&fromdate=" + fromdate + "&todate=" + todate, httpOptions );
  }

  UpdateVehicleExpense ( input: VExpense ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "VehicleExpense", body, httpOptions );
  }

  GETVehicleExpenseDetail ( intype: number, vhno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "VehicleExpense?intype=" + intype + "&vhno=" + vhno, httpOptions );
  }
  DeleteVehicleExpense ( vno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "VehicleExpense?vno=" + vno + "&iUserId=" + iUserId, httpOptions );
  }

}

